import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface MiscState {
  fetchedStudentDataFromServer: boolean
  fetchedTeacherDataFromServer: boolean
  fetchedAdminDataFromServer: boolean
  fetchedAdminStudentsFromServer: boolean
  fetchedAdminTeachersFromServer: boolean
  fetchedDistrictAdminDataFromServer: boolean
  contentfulCourseId: string | null
}

export const selectFetchedStudentDataFromServer = (state: any) => state.misc.fetchedStudentDataFromServer
export const selectFetchedAdminDataFromServer = (state: any) => state.misc.fetchedAdminDataFromServer
export const selectFetchedTeacherDataFromServer = (state: any) => state.misc.fetchedTeacherDataFromServer
export const selectFetchedAdminStudentsFromServer = (state: any) => state.misc.fetchedAdminStudentsFromServer
export const selectFetchedAdminTeachersFromServer = (state: any) => state.misc.fetchedAdminTeachersFromServer
export const selectFetchedDistrictAdminDataFromServer = (state: any) => state.misc.fetchedDistrictAdminDataFromServer
export const selectContentfulCourseId = (state: any) => state.misc.contentfulCourseId

const initialState: MiscState = {
  fetchedStudentDataFromServer: false,
  fetchedTeacherDataFromServer: false,
  fetchedAdminDataFromServer: false,
  fetchedAdminStudentsFromServer: false,
  fetchedAdminTeachersFromServer: false,
  fetchedDistrictAdminDataFromServer: false,
  contentfulCourseId: null,
}

const miscSlice = createSlice({
  name: 'misc',
  initialState,
  reducers: {
    fetchStudentDataComplete: (state) => {
      state.fetchedStudentDataFromServer = true
    },
    fetchStudentDataInProgress: (state) => {
      state.fetchedStudentDataFromServer = false
    },
    fetchTeacherDataComplete: (state) => {
      state.fetchedTeacherDataFromServer = true
    },
    fetchTeacherDataInProgress: (state) => {
      state.fetchedTeacherDataFromServer = false
    },
    fetchAdminDataComplete: (state) => {
      state.fetchedAdminDataFromServer = true
    },
    fetchAdminDataInProgress: (state) => {
      state.fetchedAdminDataFromServer = false
    },
    fetchAdminStudentsComplete: (state) => {
      state.fetchedAdminStudentsFromServer = true
    },
    fetchAdminTeachersCompete: (state) => {
      state.fetchedAdminTeachersFromServer = true
    },
    fetchDistrictAdminDataComplete: (state) => {
      state.fetchedDistrictAdminDataFromServer = true
    },
    fetchDistrictAdminDataInProgress: (state) => {
      state.fetchedDistrictAdminDataFromServer = false
    },
    updateContentfulCourseId: (state, { payload: courseId }: PayloadAction<string>) => {
      state.contentfulCourseId = courseId
    },

  },
})

export const {
  fetchStudentDataComplete,
  fetchStudentDataInProgress,
  fetchTeacherDataComplete,
  fetchTeacherDataInProgress,
  fetchAdminDataComplete,
  fetchAdminDataInProgress,
  fetchAdminStudentsComplete,
  fetchAdminTeachersCompete,
  fetchDistrictAdminDataComplete,
  fetchDistrictAdminDataInProgress,
  updateContentfulCourseId
} = miscSlice.actions

export default miscSlice.reducer
